import { Link } from "react-router-dom";

type LoungeSignInPromptProps = {
  title: string;
  message: string;
};

export const LoungeSignInPrompt = ({
  title,
  message,
}: LoungeSignInPromptProps) => {
  return (
    <div className="mw-session-signin" role="status">
      <h6 className="mid-sub" style={{ fontWeight: 600 }}>
        {title}
      </h6>
      <p className="mb-2">{message}</p>
      <Link className="btn btn-primary" to="/disneyland/login">
        Sign in
      </Link>
    </div>
  );
};
